import {Platform, StyleSheet} from 'react-native';
import {transparentize} from 'polished';

import {darkGray, onyxLight} from '/theme/color/on.color';

export const placeholderColor = darkGray;
export const disabledTextColor = transparentize(0.5, onyxLight);
export const lineHeight = 19.5;

export const styles = StyleSheet.create({
  base: {
    margin: 0,
    padding: 0,
    color: onyxLight,
    fontSize: 14,
    lineHeight,
    ...(Platform.OS === 'web' && {outlineStyle: 'none'}),
  },
  baseDisabled: {
    color: disabledTextColor,
  },
});
